import { createContext, useContext } from "react";
import { useLocation } from "react-router";
import { ERRATA, EXERCISES, EXPERIENCES, GLOSSARY, HOME, READINGS, SEARCH } from "@/book/nav";
import type { BackState } from "@/shared/ui/page-header";

/** Az oldal neve, ha nem a menüből jön (a fejezet-oldal: „3. fejezet"). */
const BackLabelContext = createContext<string | null>(null);
export const BackLabel = BackLabelContext.Provider;

const PAGE_LABELS = new Map(
  [HOME, EXERCISES, EXPERIENCES, GLOSSARY, READINGS, ERRATA, SEARCH].map((i) => [i.to, i.label]),
);

/** A gyakorlatra mutató linkek `state`-je: az aktuális oldal neve, hogy a gyakorlat
 *  fejléce oda kínáljon visszautat, ahonnan az olvasó tényleg jött (`SubHeader`). Ahol az
 *  oldalnak nincs rövid neve (pl. egy másik gyakorlat), ott a felirat „Vissza". */
export function useBackState(): BackState {
  const explicit = useContext(BackLabelContext);
  const { pathname } = useLocation();
  return { back: explicit ?? PAGE_LABELS.get(pathname.replace(/\/$/, "")) ?? "Vissza" };
}
